// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subusers-results-table{margin-left:10px;margin-right:10px}.import-users-button{margin-right:130px!important}.p-inputtext{width:100%}", ""]);
// Exports
module.exports = exports;
